module.exports = function () {

    let module = {};

    module.cartInit = function(){

        $('.btn-number').click(function(e){
            e.preventDefault();

            fieldName = $(this).attr('data-field');
            type      = $(this).attr('data-type');
            var input = $("input[name='"+fieldName+"']");
            var currentVal = parseInt(input.val());
            if (!isNaN(currentVal)) {
                if(type == 'minus') {

                    if(currentVal > input.attr('min')) {
                        input.val(currentVal - 1).change();
                    }
                    if(parseInt(input.val()) == input.attr('min')) {
                        $(this).attr('disabled', true);
                    }

                } else if(type == 'plus') {

                    if(currentVal < input.attr('max')) {
                        input.val(currentVal + 1).change();
                    }
                    if(parseInt(input.val()) == input.attr('max')) {
                        $(this).attr('disabled', true);
                    }

                }
            } else {
                input.val(0);
            }
        });
        $('.input-number').focusin(function(){
            $(this).data('oldValue', $(this).val());
        });
        $('.input-number').change(function() {

            minValue =  parseInt($(this).attr('min'));
            maxValue =  parseInt($(this).attr('max'));
            valueCurrent = parseInt($(this).val());

            name = $(this).attr('name');
            if(valueCurrent >= minValue) {
                $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
            } else {
                alert('Sorry, the minimum value was reached');
                $(this).val($(this).data('oldValue'));
            }
            if(valueCurrent <= maxValue) {
                $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
            } else {
                alert('Sorry, the maximum value was reached');
                $(this).val($(this).data('oldValue'));
            }
        });

        $(".input-number").keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });


        $('.cart-container .quantity').on('change', function () {

            let item = $(this).parents('.item');

            $.ajax({
                type: "POST",
                url: '/cart/update',
                data: {
                    'id': item.data('id'),
                    'quantity': item.find('.quantity').val(),
                },
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {


                    }
                }
            });
        });


        $('.cart-add').click(function () {

            $.ajax({
                type: "POST",
                url: '/cart/add',
                data: {
                    'id': $(this).data('id'),
                    'quantity': $(this).parents('.item').find('.quantity').val(),
                },
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {

                        let SweetAlert = require('sweetalert2');

                        SweetAlert.fire({
                            title: 'Added to order!',
                            text: 'We\'ve added this to your order list',
                            icon: 'success',
                            showCancelButton: true,
                            confirmButtonText: 'View order list',
                            cancelButtonText: 'Keep browsing'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location = "/cart";
                            }
                        })
                    }
                }
            });
        });

        $('.cart-remove').click(function () {
            let id = $(this).data("id");
            let item = $(this).parents('.item');

            $.ajax({
                type: "POST",
                url: '/cart/remove',
                data: {'id': $(this).data('id')},
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {

                        item.addClass('removed');
                        let SweetAlert2 = require('sweetalert2');

                        SweetAlert2.fire({
                            title: 'Removed from order!',
                            text: 'We\'ve removed this item from your order list',
                            icon: 'success',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Continue'
                        });

                    }
                }
            });
        });
    }

    module.enquiryDatepickers = function () {

        const AirDatepicker = require("air-datepicker/air-datepicker");

        const localeEn = require('air-datepicker/locale/en');

        let minDate = new Date;
        let maxDate = (new Date).setFullYear(minDate.getFullYear() + 1);
        let collectionDatepicker;
        let returnDatepicker;

        collectionDatepicker = new AirDatepicker('#collection_date', {
            locale: localeEn.default,
            timepicker: false,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy',
            onSelect({date}) {
                returnDatepicker.update({
                    minDate: date
                })
            }
        });

        returnDatepicker = new AirDatepicker('#return_date', {
            locale: localeEn.default,
            timepicker: false,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy'
        });


    }

    return module;

};
